/* HANNE BLOCH, the steps builder (HB 2026-10-21, Emilie's option 5 for the Resort 27 Silk Tulle Set, from her mockup
 * "Option 5, the steps, revised"). One choice a page: her colour, her length, her complimentary scarf (when that step
 * is on), her complimentary mini bag, and on the last page "Add to cart · DKK 9,700" with "Add to cart and go to
 * checkout" under it. No set page at the end: three thin lines show where she is, a quiet line under the title keeps
 * what she has chosen so far. A bottom sheet on the phone, a small window on a desktop (assets/hb-steps.css). The
 * buttons are the outlined ones of the looks' sheet (22 Oct, Emilie): grey with white words while pressed, and
 * "Added to cart" with the bag in the grey the moment she presses; the window slides down as soon as the cart has the
 * set (26 Oct, Emilie: "the speed of adding it to the cart should match the exact one as in the current live theme";
 * live's set builder and quick view slide down the moment /cart/add.js answers, and the product page shows its
 * "Added" at the press). The scarf step shows when Theme settings > the Silk Tulle Set (Resort 27) > the scarf step is
 * on (26 Oct, Emilie: "add the scarf as gift to the build my set function").
 *
 * The set's pieces come from sections/hb-set exactly as the image-first builder reads them (assets/hb-sheet.js,
 * snippets/hb-set-json: the colours with the skirt's variants and the top of that colour, the scarves, the bags), so
 * Theme settings > Collection pages: the Silk Tulle Set (Resort 27) drive both, and the cart lines are the same: the
 * skirt and the top with _hb_set, the scarf marked _hb_gift = set-scarf for the discount that makes it complimentary,
 * the mini bag reserved as RESERVE MY GIFT does (hb_gift_reserved, assets/hb-tgift.js adds it at the amount).
 * Which sets open here: the script tag's data-hb-steps-keys (silk-tulle-27; the Silk Tulle Set too while the demo
 * switch is on, and where the Silk Tulle Set's band has its campaign look). BUILD MY SET on a look's sheet
 * (assets/hb-look.js) calls HBSteps.open; ?hb_steps=<key> opens it from a link; since 26 Oct any button with
 * data-hb-steps-open="<key>" opens it too (the Silks band, Emilie's 1A on the phone and 1C on desktop, snippets/hb-set-band),
 * grey from the first touch. A set that is not a skirt-and-top pair goes to the image-first builder instead. */
import { CartUpdateEvent } from '@theme/events';

const VERSION = '2026-11-03-steps13'; // steps13 (3 Nov, Olivia): the Silks band's colours (data-hb-set-colour) open the steps on that colour; steps12 (2 Nov): sold-out scarves and bags shown sold out and never chosen, so the add is never refused for them; steps10 (27 Oct): a pick keeps the page where it was scrolled; steps9 (27 Oct): the scarves as big as the colours, in packshots; steps8: the add as quick as on live, the gifts on a line of their own on a phone, and the Silks band's BUILD MY SET (data-hb-steps-open)
// the house bag, as the header draws it (snippets/cart-icon.liquid)
const BAG =
  '<svg viewBox="0 0 502 587.18" fill="none" stroke="currentColor" stroke-width="35" aria-hidden="true"><rect x="17.5" y="226.24" width="467" height="343.44"/><path d="M251,18S153-3,130.81,226.24"/><path d="M244.82,18S342.76-3,365,226.24"/></svg>';
const MS = 350;
const SIZES_LINE = 'The top is One Size and fits XS – XXL.';
// the Fit tab's words for the two lengths (snippets/hb-pdp-details)
const LENGTHS = {
  short: '103 cm · for heights up to 165 cm / 5\'5"',
  regular: '110 cm · for heights above 165 cm / 5\'5"',
};

const ST = {
  open: false,
  dlg: null,
  html: '',
  data: null,
  key: '',
  steps: [],
  step: 0,
  color: 0,
  len: '',
  scarf: 0,
  bag: 0,
  busy: false,
  done: false,
  fmt: null,
  msg: '',
  closing: 0,
  painted: '',
};

const keys = (() => {
  const s = document.querySelector('script[data-hb-steps-keys]');
  return String((s && s.getAttribute('data-hb-steps-keys')) || 'silk-tulle-27')
    .split(',')
    .map((k) => k.trim())
    .filter(Boolean);
})();

function handles(key) {
  return keys.indexOf(String(key || '')) >= 0;
}

function esc(s) {
  return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
}

function track(name, data) {
  try {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, data || {});
  } catch (e) {
    /* analytics never breaks the builder */
  }
}

// The shop's money format, learned from two amounts Liquid rendered (as assets/hb-sheet.js does)
function moneyFormatter(samples) {
  const strip = (h) => String(h || '').replace(/<[^>]+>/g, '');
  const b = strip(samples && samples[1]);
  let m = b.match(/^([\s\S]*?)1(\D?)234(\D)56([\s\S]*)$/);
  let prefix = '';
  let suffix = '';
  let thousands = ',';
  let decimal = '.';
  let decimals = true;
  if (m) {
    prefix = m[1];
    thousands = m[2];
    decimal = m[3];
    suffix = m[4];
  } else {
    m = b.match(/^([\s\S]*?)1(\D?)235([\s\S]*)$/) || b.match(/^([\s\S]*?)1(\D?)234([\s\S]*)$/);
    decimals = false;
    if (m) {
      prefix = m[1];
      thousands = m[2];
      suffix = m[3];
    }
  }
  return (cents) => {
    const n = Math.round(Number(cents) || 0);
    const whole = Math.floor(n / 100);
    const frac = n % 100;
    const int = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    const tail = decimals && frac ? decimal + String(frac).padStart(2, '0') : '';
    return prefix + int + tail + suffix;
  };
}

// a picture URL at another width (Shopify's image_url leaves ?width= on it)
function at(src, w) {
  return String(src || '').replace(/([?&])width=\d+/, '$1width=' + w);
}

// ---------------------------------------------------------------------------------------------------------------
// The set

async function load(key) {
  let html = ST.html;
  if (!html) {
    try {
      const h = window.HBSheet && window.HBSheet.state && window.HBSheet.state.setHtml;
      if (h) html = h;
    } catch (e) {
      /* nothing */
    }
  }
  if (!html) {
    try {
      const res = await fetch('/?section_id=hb-set', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('hb-set ' + res.status);
      html = await res.text();
    } catch (e) {
      html = '';
    }
  }
  ST.html = html;
  if (!html) return null;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const el = doc.querySelector('[data-hb-set-data]');
  let all = null;
  try {
    all = el ? JSON.parse(el.textContent) : null;
  } catch (e) {
    all = null;
  }
  const sets = all && Array.isArray(all.sets) ? all.sets : [];
  const d = sets.find((s) => s && s.key === key) || null;
  if (!d || !Array.isArray(d.colors) || !d.colors.length) return null;
  d.money = all.money;
  d.scarves = Array.isArray(d.scarves) ? d.scarves : [];
  d.bags = Array.isArray(d.bags) ? d.bags : [];
  // HB 2026-11-02 (Olivia: "it does not add to cart", then "it should display as sold out"): snippets/hb-set-json lists
  // sold-out scarves and bags too, with "avail": false. They stay on their pages, shown sold out and not choosable (as
  // the lengths are, and as the image-first builder crosses them out), and a sold-out one is never chosen for her: the
  // White scarf was sold out and still chosen for a White set, so /cart/add.js refused the whole set ("Not added, try
  // again"). No scarf in stock at all: no scarf step, one gift fewer; the same for the bags.
  // the colours as the image-first builder orders them: the set's lead colour first, then White first and Black last
  const lead = String(d.lead || '').trim().toLowerCase();
  const rank = (n) => (lead && String(n).trim().toLowerCase() === lead ? -1 : /^white$/i.test(String(n).trim()) ? 0 : /^black$/i.test(String(n).trim()) ? 2 : 1);
  d.colors.sort((a, b) => rank(a.name) - rank(b.name));
  d.scarves.sort((a, b) => rank(a.name) - rank(b.name));
  return d;
}

const colour = () => ST.data.colors[ST.color];
const lenVar = (c, k) => (c ? c.main.vars.find((v) => v.k === k) || null : null);

// Short before Regular, as the site's picker
function lens(c) {
  const rank = (v) => (/short/i.test(v.k) ? 0 : /regular/i.test(v.k) ? 1 : 2);
  return c.main.vars.slice().sort((a, b) => rank(a) - rank(b));
}
// her first length: the Regular when it is in stock (the pair's rule, Vic round 52), else the first in stock
function defaultLen(c) {
  const vs = c.main.vars;
  const reg = vs.find((v) => /regular/i.test(v.k) && v.avail);
  const first = vs.find((v) => v.avail) || vs[0];
  return (reg || first || { k: '' }).k;
}
const inStock = (o) => !!o && o.avail !== false;
// her set's colour when that scarf is in stock, else the first scarf in stock, else none (-1)
function scarfOf(c) {
  const list = ST.data.scarves;
  const i = list.findIndex((s) => inStock(s) && String(s.name).toLowerCase() === String(c.name).toLowerCase());
  return i >= 0 ? i : list.findIndex(inStock);
}
const firstBag = () => ST.data.bags.findIndex(inStock);

function steps() {
  const d = ST.data;
  const c = colour();
  const out = ['color'];
  if (c && c.main.vars.length > 1) out.push('length');
  if (d.scarfOn && d.scarves.some(inStock)) out.push('scarf');
  if (d.bagOn && d.bags.some(inStock)) out.push('bag');
  return out;
}

function pick() {
  const d = ST.data;
  const c = colour();
  const main = lenVar(c, ST.len) || (c ? c.main.vars[0] : null);
  const second = c ? c.second : null;
  const sc0 = d.scarfOn && ST.scarf >= 0 ? d.scarves[ST.scarf] || null : null;
  const bg0 = d.bagOn && ST.bag >= 0 ? d.bags[ST.bag] || null : null;
  const scarf = inStock(sc0) ? sc0 : null;
  const bag = inStock(bg0) ? bg0 : null;
  const total = (main ? main.cents : 0) + (second ? second.cents : 0);
  const was = total + (scarf ? scarf.cents : 0) + (bag ? bag.cents : 0);
  const ok = !!(main && main.avail) && !!second && !!second.avail;
  return { c, main, second, scarf, bag, total, was, ok };
}

function gifts() {
  const d = ST.data;
  return (d.scarfOn && d.scarves.some(inStock) ? 1 : 0) + (d.bagOn && d.bags.some(inStock) ? 1 : 0);
}

// ---------------------------------------------------------------------------------------------------------------
// The window

const CHEV_L = '<svg viewBox="0 0 7 11" fill="none" aria-hidden="true"><path d="M6 1L1.5 5.5 6 10" stroke="currentColor" stroke-width="1.2"/></svg>';
const X = '<svg viewBox="0 0 11 11" fill="none" aria-hidden="true"><path d="M1 1l9 9M10 1l-9 9" stroke="currentColor" stroke-width="1.2"/></svg>';

function ensure() {
  if (ST.dlg) return ST.dlg;
  const dlg = document.createElement('dialog');
  dlg.className = 'hb-steps';
  dlg.setAttribute('data-hb-steps', '');
  dlg.innerHTML =
    '<span class="hb-steps__handle" aria-hidden="true"></span>' +
    '<div class="hb-steps__bar"><button type="button" class="hb-steps__back" data-hb-steps-back aria-label="Back">' + CHEV_L + '</button>' +
    '<span class="hb-steps__title" data-hb-steps-title></span>' +
    '<button type="button" class="hb-steps__x" data-hb-steps-close aria-label="Close">' + X + '</button></div>' +
    '<div class="hb-steps__prog" data-hb-steps-prog aria-hidden="true"></div>' +
    '<p class="hb-steps__sofar" data-hb-steps-sofar></p>' +
    '<div class="hb-steps__body" data-hb-steps-body></div>' +
    '<div class="hb-steps__foot" data-hb-steps-foot></div>';
  document.body.appendChild(dlg);
  dlg.addEventListener('click', onClick);
  // the press shows at once (22 Oct, Emilie): the grey goes on at pointerdown, before the click, and comes off when
  // the finger or the button lifts (the click keeps it with is-busy); the empty touchstart listener is for iOS,
  // which applies :active only when something listens for a touch
  dlg.addEventListener('pointerdown', (e) => {
    const b = e.target instanceof Element ? e.target.closest('.hb-steps__cta') : null;
    if (b && !b.disabled) b.classList.add('is-pressed');
  });
  // the pressed look leaves a frame after the finger lifts, so a tap's click (is-busy) takes over without a flicker
  const unpress = () => dlg.querySelectorAll('.hb-steps__cta.is-pressed').forEach((b) => b.classList.remove('is-pressed'));
  const release = () => {
    requestAnimationFrame(unpress);
    setTimeout(unpress, 120); // a page without frames for a moment (hidden, or iOS mid-gesture) still lets go
  };
  dlg.addEventListener('pointerup', release);
  dlg.addEventListener('pointercancel', release);
  dlg.addEventListener('touchstart', () => {}, { passive: true });
  dlg.addEventListener('cancel', (e) => {
    e.preventDefault();
    close();
  });
  ST.dlg = dlg;
  return dlg;
}

function show() {
  const dlg = ensure();
  if (!dlg.open) dlg.showModal();
  document.documentElement.style.overflow = 'hidden';
  requestAnimationFrame(() => requestAnimationFrame(() => dlg.classList.add('is-in')));
}

function close() {
  const dlg = ST.dlg;
  if (!dlg || !ST.open) return;
  ST.open = false;
  dlg.classList.remove('is-in');
  document.documentElement.style.overflow = '';
  clearTimeout(ST.closing);
  ST.closing = setTimeout(() => {
    if (dlg.open) dlg.close();
  }, MS);
}

async function open(key, opener) {
  if (ST.open) return;
  key = key || keys[0];
  ST.open = true;
  ST.key = key;
  ST.data = null;
  ST.busy = false;
  ST.done = false;
  ST.msg = '';
  const dlg = ensure();
  dlg.querySelector('[data-hb-steps-title]').textContent = '';
  dlg.querySelector('[data-hb-steps-prog]').innerHTML = '';
  dlg.querySelector('[data-hb-steps-sofar]').textContent = '';
  dlg.querySelector('[data-hb-steps-body]').innerHTML = '<div class="hb-steps__wait">One moment</div>';
  dlg.querySelector('[data-hb-steps-foot]').innerHTML = '';
  dlg.querySelector('[data-hb-steps-back]').hidden = true;
  show();
  track('hb_steps_open', { set: key });
  const d = await load(key);
  if (!ST.open) return;
  if (!d) {
    dlg.querySelector('[data-hb-steps-body]').innerHTML = '<div class="hb-steps__wait">The set is not available right now.</div>';
    return;
  }
  // only a skirt-and-top pair is built here; another shape goes to the image-first builder
  if (d.kind !== 'pair' || !d.lock2) {
    close();
    setTimeout(() => {
      if (window.HBSheet && typeof window.HBSheet.openSet === 'function') window.HBSheet.openSet(opener || null, key, { start: true });
    }, MS + 40);
    return;
  }
  ST.data = d;
  ST.fmt = moneyFormatter(d.money);
  ST.painted = '';
  ST.step = 0;
  ST.color = 0;
  // HB 2026-11-03 (Olivia, the Silks band): a colour on the band (snippets/hb-set-band, data-hb-set-colour) starts the
  // steps on that colour, as the image-first builder did
  const wantC = opener && opener.getAttribute ? opener.getAttribute('data-hb-set-colour') : '';
  if (wantC) {
    const wi = d.colors.findIndex((c) => c && c.name === wantC);
    if (wi > 0) ST.color = wi;
  }
  ST.len = defaultLen(d.colors[ST.color]);
  ST.scarf = scarfOf(d.colors[ST.color]);
  ST.bag = firstBag();
  ST.steps = steps();
  paint();
}

// ---------------------------------------------------------------------------------------------------------------
// The pages

function nextWords(i) {
  const s = ST.steps[i + 1];
  return s === 'length' ? 'the length' : s === 'scarf' ? 'your scarf' : s === 'bag' ? 'your mini bag' : '';
}

function pageColour() {
  const d = ST.data;
  return (
    '<h3 class="hb-steps__h">Your color</h3>' +
    '<div class="hb-steps__tiles' + (d.colors.length > 2 ? ' hb-steps__tiles--many' : '') + '">' +
    d.colors
      .map((c, i) => {
        const src = at(c.look || c.main.img, 600);
        return (
          '<button type="button" class="hb-steps__tile' + (i === ST.color ? ' is-on' : '') + '" data-hb-steps-color="' + i + '" aria-pressed="' + (i === ST.color ? 'true' : 'false') + '">' +
          '<span class="hb-steps__pic"><img src="' + esc(src) + '" alt="' + esc(c.name + ' ' + d.pieces) + '" loading="lazy"></span>' +
          '<span class="hb-steps__cap"><em>' + esc(c.name) + '</em><span>' + esc(d.pieces) + '</span></span></button>'
        );
      })
      .join('') +
    '</div>'
  );
}

function pageLength() {
  const c = colour();
  // HB 2026-11-04 (Vic): every Short is cut from a Regular and sent at once, so a Short sold on at 0 while its Regular is
  // in stock is an ordinary length: no date, no "Pre-order" (the 2026 Pink Short)
  const regIn = lens(c).some((x) => /regular/i.test(String(x.k)) && x.avail && !x.pre);
  return (
    '<h3 class="hb-steps__h">Your length</h3>' +
    '<div class="hb-steps__opts">' +
    lens(c)
      .map((v) => {
        const k = String(v.k).toLowerCase();
        const line = LENGTHS[k] || '';
        const on = v.k === ST.len;
        // HB 2026-11-04 (Vic): no "Pre-order" (DECISIONS 221); a length on its way shows its date mildly under the line,
        // "Arrives Nov 13" from Theme settings > Product page: pieces on their way (the PDP's trust line), nothing without a date
        const sub = v.avail ? line : 'Sold out';
        const cut = regIn && /short/i.test(String(v.k));
        const later = v.avail && v.pre && !cut && ST.data && ST.data.later ? 'Arrives ' + ST.data.later : '';
        return (
          '<button type="button" class="hb-steps__opt' + (on ? ' is-on' : '') + (v.avail ? '' : ' is-out') + '" data-hb-steps-len="' + esc(v.k) + '"' + (v.avail ? '' : ' disabled') + ' aria-pressed="' + (on ? 'true' : 'false') + '">' +
          '<em>' + esc(v.k) + '</em><span>' + esc(sub) + (later ? '<small class="hb-steps__later">' + esc(later) + '</small>' : '') + '</span></button>'
        );
      })
      .join('') +
    '</div>' +
    '<p class="hb-steps__note">' + esc(SIZES_LINE) + ' Between the two lengths? We recommend the Regular.</p>'
  );
}

// a row of small tiles (the bags; the scarves had them until 27 Oct), the chosen one named under it with its price struck and "Complimentary"
function row(list, on, attr, alt) {
  const chosen = list[on] || list[0];
  return (
    '<div class="hb-steps__row">' +
    list
      .map((o, i) => {
        const out = !inStock(o);
        return (
          '<button type="button" class="hb-steps__sq' + (i === on ? ' is-on' : '') + (out ? ' is-out' : '') + '" ' + attr + '="' + i + '"' + (out ? ' disabled' : '') + ' aria-pressed="' + (i === on ? 'true' : 'false') + '" aria-label="' + esc(o.title || o.name) + (out ? ', sold out' : '') + '">' +
          '<img src="' + esc(at(o.thumb || o.img, 240)) + '" alt="" loading="lazy"></button>'
        );
      })
      .join('') +
    '</div>' +
    (chosen ? '<p class="hb-steps__chosen"><b>' + esc(chosen.title || chosen.name) + '</b><span><s>' + esc(ST.fmt(chosen.cents)) + '</s> Complimentary</span></p>' : '')
  );
}

// the scarves as big as the colours (27 Oct, Emilie: "the image of the scarfs needs to be as big as the skirts in the first
// image ... the scarf should just be packshot of scarf"): the colour page's tiles, the scarf's packshot (snippets/hb-set-json
// "pack"), its name and under it the price struck with Complimentary
function pageScarf() {
  const d = ST.data;
  return (
    '<h3 class="hb-steps__h">Your complimentary Silk Tulle Scarf<small>In your set\u2019s color, or another</small></h3>' +
    '<div class="hb-steps__tiles' + (d.scarves.length > 2 ? ' hb-steps__tiles--many' : '') + '">' +
    d.scarves
      .map((s, i) => {
        const on = i === ST.scarf;
        const out = !inStock(s);
        const src = at(s.pack || s.img || s.thumb, 600);
        return (
          '<button type="button" class="hb-steps__tile' + (on ? ' is-on' : '') + (out ? ' is-out' : '') + '" data-hb-steps-scarf="' + i + '"' + (out ? ' disabled' : '') + ' aria-pressed="' + (on ? 'true' : 'false') + '"' + (out ? ' aria-label="' + esc(s.title || s.name) + ', sold out"' : '') + '>' +
          '<span class="hb-steps__pic"><img src="' + esc(src) + '" alt="' + esc(s.title || s.name) + '" loading="lazy"></span>' +
          '<span class="hb-steps__cap hb-steps__cap--gift"><em>' + esc(s.name) + '</em>' + (out ? '<span>Sold out</span>' : '<span><s>' + esc(ST.fmt(s.cents)) + '</s> Complimentary</span>') + '</span></button>'
        );
      })
      .join('') +
    '</div>'
  );
}

function pageBag() {
  const d = ST.data;
  return '<h3 class="hb-steps__h">Your complimentary mini bag<small>Our gift with your order</small></h3>' + row(d.bags, ST.bag, 'data-hb-steps-bag') + total(pick());
}

function total(p) {
  return '<div class="hb-steps__tot"><b>Total</b><span>' + (p.was > p.total ? '<s>' + esc(ST.fmt(p.was)) + '</s> ' : '') + esc(ST.fmt(p.total)) + '</span></div>';
}

function paint() {
  const dlg = ST.dlg;
  const d = ST.data;
  if (!dlg || !d) return;
  ST.steps = steps();
  if (ST.step > ST.steps.length - 1) ST.step = ST.steps.length - 1;
  const cur = ST.steps[ST.step];
  const last = ST.step === ST.steps.length - 1;
  const p = pick();
  const g = gifts();
  // the title, and the gifts after it: on one line on a desktop, the gifts on a line of their own on a phone, where the
  // two do not fit beside the back arrow and the x (26 Oct: with the scarf it reads "with 2 gifts from us")
  dlg.querySelector('[data-hb-steps-title]').innerHTML =
    '<span>' + esc(String(d.cap || 'Your set').toUpperCase()) + '</span>' +
    (g ? '<span class="hb-steps__gifts"><i> · </i>WITH ' + g + (g > 1 ? ' GIFTS' : ' GIFT') + ' FROM US</span>' : '');
  dlg.querySelector('[data-hb-steps-prog]').innerHTML = ST.steps.map((s, i) => '<i' + (i <= ST.step ? ' class="is-on"' : '') + '></i>').join('');
  const sofar = [];
  ST.steps.slice(0, ST.step).forEach((s) => {
    if (s === 'color' && p.c) sofar.push(p.c.name);
    if (s === 'length' && p.main) sofar.push(p.main.k);
    if (s === 'scarf' && p.scarf) sofar.push(p.scarf.name + ' scarf');
  });
  dlg.querySelector('[data-hb-steps-sofar]').textContent = sofar.join(' · ');
  dlg.querySelector('[data-hb-steps-back]').hidden = ST.step === 0;
  let body = '';
  if (cur === 'color') body = pageColour() + (last ? total(p) : '');
  else if (cur === 'length') body = pageLength() + (last ? total(p) : '');
  else if (cur === 'scarf') body = pageScarf() + (last ? total(p) : '');
  else if (cur === 'bag') body = pageBag();
  const bodyEl = dlg.querySelector('[data-hb-steps-body]');
  // 27 Oct (Emilie: "when i scroll down and choose a scarf or a color ... it scrolls up ... it should stay on the set or scarf
  // that i chose"): a pick on the same page keeps the page where it was; a new page starts at its top
  const page = ST.step + ':' + cur;
  const keep = ST.painted === page ? bodyEl.scrollTop : 0;
  bodyEl.innerHTML = body;
  bodyEl.scrollTop = keep;
  ST.painted = page;
  let foot;
  if (!last) {
    foot = '<button type="button" class="hb-steps__cta" data-hb-steps-next>Next <i></i> ' + esc(nextWords(ST.step)) + '</button>';
  } else {
    // the outlined button reads "Added to cart" with the bag the moment she presses (is-done, in the grey) and keeps it
    // while the window slides down; for "go to checkout" it keeps its words in the grey (is-busy) until checkout opens
    const words = ST.done ? 'Added to cart ' + BAG : p.ok || ST.busy ? 'Add to cart <i></i> ' + esc(ST.fmt(p.total)) : 'Not available right now';
    const held = ST.busy || ST.done;
    foot =
      '<button type="button" class="hb-steps__cta' + (ST.busy ? ' is-busy' : '') + (ST.done ? ' is-done' : '') + '" data-hb-steps-add' + (held || !p.ok ? ' disabled' : '') + '>' + words + '</button>' +
      '<button type="button" class="hb-steps__quiet" data-hb-steps-checkout' + (held || !p.ok ? ' disabled' : '') + '>Add to cart and go to checkout</button>' +
      '<p class="hb-steps__msg" aria-live="polite">' + esc(ST.msg) + '</p>';
  }
  dlg.querySelector('[data-hb-steps-foot]').innerHTML = foot;
}

function onClick(e) {
  const t = e.target instanceof Element ? e.target : null;
  if (!t) return;
  if (t === ST.dlg) {
    close();
    return;
  }
  const d = ST.data;
  if (t.closest('[data-hb-steps-close]')) {
    close();
    return;
  }
  if (t.closest('[data-hb-steps-back]')) {
    if (ST.step > 0) ST.step -= 1;
    paint();
    return;
  }
  if (!d || ST.busy || ST.done) return;
  const col = t.closest('[data-hb-steps-color]');
  if (col) {
    const i = Number(col.getAttribute('data-hb-steps-color')) || 0;
    if (i !== ST.color) {
      ST.color = i;
      const c = colour();
      ST.len = defaultLen(c);
      ST.scarf = scarfOf(c);
    }
    paint();
    return;
  }
  const len = t.closest('[data-hb-steps-len]');
  if (len) {
    ST.len = len.getAttribute('data-hb-steps-len') || ST.len;
    paint();
    return;
  }
  const sc = t.closest('[data-hb-steps-scarf]');
  if (sc) {
    const i = Number(sc.getAttribute('data-hb-steps-scarf')) || 0;
    if (inStock(d.scarves[i])) ST.scarf = i;
    paint();
    return;
  }
  const bag = t.closest('[data-hb-steps-bag]');
  if (bag) {
    const i = Number(bag.getAttribute('data-hb-steps-bag')) || 0;
    if (inStock(d.bags[i])) ST.bag = i;
    paint();
    return;
  }
  if (t.closest('[data-hb-steps-next]')) {
    if (ST.step < ST.steps.length - 1) ST.step += 1;
    track('hb_steps_next', { set: ST.key, step: ST.steps[ST.step] });
    paint();
    return;
  }
  if (t.closest('[data-hb-steps-add]')) commit(false);
  else if (t.closest('[data-hb-steps-checkout]')) commit(true);
}

// ---------------------------------------------------------------------------------------------------------------
// Into the cart, exactly as the image-first builder adds a set (assets/hb-sheet.js, commitSet)

const post = (path, body) =>
  fetch(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  }).then((r) => {
    if (!r.ok) throw new Error(path + ' ' + r.status);
    return r.json();
  });

// The gift's script puts the reserved bag in once the cart is over the amount; wait for it (at most 5 s)
async function bagInCart(bag) {
  const g = window.HBGift;
  if (!bag || !g) return;
  try {
    if (typeof g.refresh === 'function') g.refresh();
  } catch (e) {
    /* nothing */
  }
  const until = performance.now() + 5000;
  while (performance.now() < until) {
    try {
      const st = g.state && g.state.cur;
      if (st && st.bagKey) return;
      if (st && st.on === false) return;
    } catch (e) {
      return;
    }
    await new Promise((r) => setTimeout(r, 150));
  }
}

async function commit(checkout) {
  if (ST.busy || !ST.data) return;
  const d = ST.data;
  const p = pick();
  if (!p.ok) return;
  ST.busy = true;
  // "Added to cart" at the press, as the product page's button does on live (26 Oct); going to checkout keeps the words
  ST.done = !checkout;
  ST.msg = '';
  paint();
  const props = { _hb_set: d.key };
  const items = [{ id: Number(p.main.id), quantity: 1, properties: props }, { id: Number(p.second.id), quantity: 1, properties: props }];
  // the scarf is marked for the discount that makes it complimentary (_hb_gift = set-scarf), as the image-first builder marks it
  if (p.scarf) items.push({ id: Number(p.scarf.id), quantity: 1, properties: { _hb_set: d.key, _hb_gift: 'set-scarf' } });
  try {
    // her mini bag, reserved exactly as RESERVE MY GIFT does (assets/hb-tgift.js reads the attribute and adds the bag at the amount)
    if (p.bag) await post('/cart/update.js', { attributes: { hb_gift_reserved: p.bag.handle } });
    const data = await post('/cart/add.js', { items });
    try {
      if (typeof window.triggerKlaviyoAddedToCart === 'function') window.triggerKlaviyoAddedToCart(data);
    } catch (e) {
      /* nothing */
    }
    track('hb_steps_add', { set: d.key, color: p.c.name, length: p.main.k, scarf: p.scarf ? p.scarf.name : '', bag: p.bag ? p.bag.handle : '', total: p.total, checkout: !!checkout });
    if (checkout) {
      await bagInCart(p.bag);
      location.href = '/checkout';
      return;
    }
    // keep browsing: the quick add's own note rises with the set's name and picture; the cart stays closed
    try {
      if (window.HBCart && window.HBCart.state) window.HBCart.state.qaPiece = { name: p.c.name + ' ' + (d.setName || 'set'), img: p.c.main.img || '', at: performance.now() };
    } catch (e) {
      /* the note then shows without the piece */
    }
    // the window slides down now, "Added to cart" still on its button, and the note rises as it finishes (live's builder)
    ST.busy = false;
    close();
    setTimeout(() => {
      ST.done = false;
      document.dispatchEvent(new CartUpdateEvent({ source: 'variant-popup-inner' }));
      try {
        if (window.HBGift && typeof window.HBGift.refresh === 'function') window.HBGift.refresh();
      } catch (e) {
        /* nothing */
      }
    }, MS + 20);
  } catch (e) {
    ST.busy = false;
    ST.done = false;
    ST.msg = 'Not added, try again';
    paint();
  }
}

// ---------------------------------------------------------------------------------------------------------------

function init() {
  window.HBSteps = { version: VERSION, open, close, handles, keys, state: ST };
  // HB 2026-10-26 (Emilie, the Silks page): a button (or the picture) with data-hb-steps-open="<key>" opens the steps
  // on that set; a set these steps do not take goes to the image-first builder, as open() does with one that is not a pair
  document.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target.closest('[data-hb-steps-open]') : null;
    if (!t || t.closest('dialog')) return;
    e.preventDefault();
    const k = t.getAttribute('data-hb-steps-open') || keys[0];
    if (handles(k)) open(k, t);
    else if (window.HBSheet && typeof window.HBSheet.openSet === 'function') {
      const c = t.getAttribute('data-hb-set-colour');
      window.HBSheet.openSet(t, k, c ? { color: c, start: true } : { start: true });
    }
  });
  // the grey at the first touch on the band's button (the builder's own buttons have it in their :active)
  document.addEventListener(
    'pointerdown',
    (e) => {
      const b = e.target instanceof Element ? e.target.closest('.hb-camp__btn') : null;
      if (!b) return;
      b.classList.add('is-pressed');
      const off = () => {
        window.removeEventListener('pointerup', off);
        window.removeEventListener('pointercancel', off);
        setTimeout(() => b.classList.remove('is-pressed'), 120);
      };
      window.addEventListener('pointerup', off);
      window.addEventListener('pointercancel', off);
    },
    { passive: true }
  );
  // a link straight to the builder: ?hb_steps=<key>
  try {
    const want = new URLSearchParams(location.search).get('hb_steps');
    if (want && handles(want)) setTimeout(() => open(want, null), 400);
  } catch (e) {
    /* nothing */
  }
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
